// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/src--components.json";
import part1 from "./en/src--flow--components--steps.json";
import part2 from "./en/src--flow--components.json";
import part3 from "./en/src--hooks.json";
import part4 from "./en/src--receiving-source.json";
import part5 from "./en/src--utils.json";
import part6 from "./en/src.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
  part3,
  part4,
  part5,
  part6,
);
